import Vue from 'vue';
import {ApckPortletApexChart} from "../portlet";

export const ApckPortletUnfixedVulns = /*#__PURE__*/ ApckPortletApexChart.extend({
    props: {
        ctype: {
            type: String,
            default: "unfixedportlet"
        },
        title: {
            type: String,
            default: "Vulnerabilities status"
        },
        size: {
            type: String,
            default: "md"
        },
        description: {
            type: String,
            default: "Counter showing the total number of unfixed vulnerabilities"
        },
        src: {
            type: String,
            default: "/unfixed"
        },
        chartType: {
            type: String,
            default: 'bar',
        },
        defaultChartOptions: {
            type: Object,
            default: function () {
                return {
                    chart: {
                        stacked: true,
                        toolbar: {
                            tools: {
                                download: false,
                            },
                        },
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        width: 1,
                        colors: ["#fff"]
                    },
                    fill: {
                        opacity: 1
                    },
                    legend: {
                        position: "top",
                        horizontalAlign: "center",
                        offsetY: 20,
                        markers: {
                            fillColors: ["#000", "#aaa"],
                        },
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: true
                            }
                        },
                        yaxis: {
                            lines: {
                                show: true
                            }
                        },
                    },
                    states: {
                        active: {
                            filter: {
                                type: 'none'
                            }
                        },
                        hover: {
                            filter: {
                                type: 'none',
                            }
                        },
                    },
                }
            }
        },
    },
    created() {
        const cmp = this;

        const labelMap = {
            'critical': '5.0-critical',
            'high': '4.0-high',
            'medium': '3.0-medium',
            'low': '2.0-low',
            'info': '1.0-info',
        }
        // register chart click actions
        const events = {
            dataPointSelection: function (event, chartContext, opts) {
                const selectedSeries = opts.w.config.series[opts.seriesIndex];
                const status_text = selectedSeries.name.toLowerCase();
                const selectedLabel = selectedSeries.data[opts.dataPointIndex].x.toLowerCase();

                const status = status_text === 'fixed' ? ['fixed', 'false_positive', 'acceptable_risk'] : ['unfixed'];

                const params = new URLSearchParams({
                    impact: labelMap[selectedLabel.toLowerCase()],
                });
                status.forEach(item => {params.append('status', item)});
                const href = '/vulnerabilities?' + params.toString();
                window.open(href, '_blank').focus();
            }
        };

        this.chartOptions.chart = this.chartOptions.chart || {};
        this.chartOptions.chart.events = {...this.chartOptions.chart.events, ...events};
    },
    methods: {
        parseData: function(data) {
            this.chartSeries = data.datasets;
        },
    },
    data: function () {
        return {
            options: {
                show_fixed: {
                    type: "boolean",
                    default: true,
                    label: "Show fixed"
                },
            }
        };
    },
});
